import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '@lore/auth';
import ParentLayout from './Layout';
import useRouter from '../../hooks/useRouter';
import Loader from '../../components/Loader';
import { useQueryMutation } from '../../../hooks/@lore/query-connect';
import myLeadingWithSelector from '../_post-opportunity/myLeadingWithSelector';

export default function Layout() {
  const { history } = useRouter();
  const navigate = useNavigate();

  const user = useUser();

  const mutation = useQueryMutation('event.create');
  const { success, isError, request } = mutation;

  useEffect(() => {
    if (success) {
      history.push(`/post-event/${request.id}`)
    }
  }, [success]);

  useEffect(() => {
    if (isError) {
      navigate(myLeadingWithSelector(), { replace: true });
    }
  }, [isError, navigate]);

  useEffect(() => {
    mutation.mutate({
      creatorId: user.id
    });
  }, []);

  return (
    <ParentLayout
      page="Create event"
      title={(
        <Loader/>
      )}
    >
      <div className="px-16 lg:px-32 pt-32">
        <Loader/>
      </div>
    </ParentLayout>
  );
};
